
import { createSelector } from 'reselect'
import { LoadedState, Field, FieldValue } from './types';
import FormPro from '../jquery.formpro-common.js';

const getOriginalTableRow = (state: LoadedState) => state.originalTableRow;
const getTableRow = (state: LoadedState) => state.tableRow;


export const getChangesToSave = createSelector(
	[getOriginalTableRow,getTableRow],
	(originalTableRow,tableRow) => {
		let changes = {};
		for(const fieldId in originalTableRow) {
		  var newValue = JSON.stringify(tableRow[fieldId]);
		  if(JSON.stringify(originalTableRow[fieldId]) !== newValue) {
		    changes[fieldId] = JSON.parse(newValue);
		  }
		}
		return changes;
	}
);

const getFields = (state: LoadedState) => state.fields;

export const getMissingRequiredFields = createSelector(
	[getTableRow,getFields],
	(tableRow,fields) => {
		const missingRequired = {};
		for (const field of fields) {

            if (field.conditionalVisibility) {
                const filterGroup = new FormPro.RecordFilterGroup(JSON.parse(field.conditionalVisibility));

				// Convert rows in format needed by RecordFilterGroup
				let rows = fields;
				rows.forEach(function(field) {
					field.values = [{value: tableRow[field.id]}];
                });

                const neededInfos = { utilisateur_code: '', carnet_code: '', carnet_owner: '' };    // Filter using user_code and carnet_code will not works

                // Return an empty array if row has been filtered
                const hideField = filterGroup.filterRows(rows, neededInfos).length == 0;
                if (hideField) {
                    continue;
                }
            }

			if(field.required && isEmptyValue(tableRow[field.id])) {
				missingRequired[field.id] = true;
			}
		}
		return missingRequired;
	}
);

function isEmptyValue(value: any):boolean {
	return (
		value===undefined ||
		value===null || 
		(typeof value === "string" && value.length===0) ||
		(value instanceof Array && value.length===0) ||
		(typeof value === "object" && value.hasOwnProperty('value') && isEmptyValue(value.value))
	);
}

const getEnumForeignField = (state: LoadedState, field : Field) => {
	for (const fieldIndex in state.fields) {
		if (state.fields[fieldIndex].id == field.condEnumForeign!.enumForeign_field_id)
			return state.fields[fieldIndex];
	}
	return null;
};

export const getForeignProps = createSelector(
	[getEnumForeignField, getTableRow], (field, tableRow) => {
			return (field !== null) ? tableRow[field.id] : field;
	}
);



// WEBPACK FOOTER //
// ./src/store/selectors.ts